export function getArrayObject(array, key, value) {
    return array.filter(item => {
        if (item.key && item.key === value) return item;
    });
}

export function combineArguments(inputArguments) {
    let queryObject = {};

    for (const key in inputArguments) {
        if (inputArguments.hasOwnProperty(key)) {
            Object.assign(queryObject, inputArguments[key]);
        }
    }

    return queryObject;
}
